import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import * as Highcharts from "highcharts";
import { LargeNumberPipe } from "@modules/core/pipes/large-number.pipe";
import { ColumnChartConfig } from "@modules/shared/chart/models/chart-config.model";
import { getColumnChartConfig } from "@modules/shared/chart/utils/chart-utils";

@Component({
	selector: "column-chart",
	templateUrl: "./column-chart.component.html",
	styleUrls: ["./column-chart.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [LargeNumberPipe],
	standalone: false
})
export class ColumnChartComponent {
	@Input() public set chartConfig(config: ColumnChartConfig) {
		if (config) {
			this.updateSeries(config);
		}
	}

	public Highcharts: typeof Highcharts = Highcharts;
	public isChartUpdated: boolean = false;
	public chartOptions: Highcharts.Options = getColumnChartConfig();

	public constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private largeNumberPipe: LargeNumberPipe
	) {}

	private updateSeries(config: ColumnChartConfig): void {
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const that = this;

		this.chartOptions.xAxis = {
			categories: config.categories
		};

		// @ts-ignore
		this.chartOptions.yAxis.labels = {
			formatter: function () {
				return that.largeNumberPipe.transform(this.value);
			}
		};

		this.chartOptions.series = [
			{
				data: config.data,
				type: "column"
			}
		];

		// Refresh the view
		this.isChartUpdated = true;
		this.changeDetectorRef.markForCheck();
	}
}
